import React from "react";
import { GridLegacy } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function Algemeen() {
  return (
    <Card style={{ maxWidth: 600 }}>
      <CardBody style={{ padding: 16 }}>
        <GridLegacy container spacing={1}>
          <FormTextTC name={"orderCount"} tDefault={"Order count"} tKey={"relations.form.algemeen.label.orderCount"} />
          <FormTextTC name={"apiId"} tDefault={"Api ID"} tKey={"relations.form.algemeen.label.apiid"} />
          <FormTextTC
            name={"companyName"}
            tDefault={"Bedrijfsnaam"}
            tKey={"relations.form.algemeen.label.companyName"}
          />
          <FormTextTC name={"firstName"} tDefault={"Voornaam"} tKey={"relations.form.algemeen.label.firstName"} />
          <FormTextTC name={"prefix"} tDefault={"Tussenvoegsel"} tKey={"relations.form.algemeen.label.prefix"} />
          <FormTextTC name={"lastName"} tDefault={"Achternaam"} tKey={"relations.form.algemeen.label.lastName"} />
          <FormTextTC
            name={"addressLine1"}
            tDefault={"Adress regel 1"}
            tKey={"relations.form.algemeen.label.addressLine1"}
          />
          <FormTextTC
            name={"addressLine2"}
            tDefault={"Adress regel 2"}
            tKey={"relations.form.algemeen.label.addressLine2"}
          />
          <FormTextTC name={"zipcode"} tDefault={"Postcode"} tKey={"relations.form.algemeen.label.zipcode"} />
          <FormTextTC name={"city"} tDefault={"Plaats"} tKey={"relations.form.algemeen.label.city"} />
          <FormTextTC name={"country"} tDefault={"Land"} tKey={"relations.form.algemeen.label.country"} />
          <FormTextTC name={"email"} tDefault={"E-Mail"} tKey={"relations.form.algemeen.label.email"} />
          <FormTextTC name={"phone"} tDefault={"Telefoon"} tKey={"relations.form.algemeen.label.phone"} />
          <FormTextTC name={"mobile"} tDefault={"Mobile"} tKey={"relations.form.algemeen.label.mobile"} />
          <FormTextTC name={"CardNumber"} tDefault={"CardNumber"} tKey={"relations.form.algemeen.label.CardNumber"} />
          <FormTextTC name={"Code"} tDefault={"Code"} tKey={"relations.form.algemeen.label.Code"} />
          <FormTextTC
            name={"AccountBalance"}
            tDefault={"AccountBalance"}
            tKey={"relations.form.algemeen.label.AccountBalance"}
          />
          <FormTextTC
            name={"AccountLimit"}
            tDefault={"AccountLimit"}
            tKey={"relations.form.algemeen.label.AccountLimit"}
          />
          <FormTextTC name={"SavePoints"} tDefault={"SavePoints"} tKey={"relations.form.algemeen.label.SavePoints"} />
          <FormTextTC name={"SaveAmount"} tDefault={"SaveAmount"} tKey={"relations.form.algemeen.label.SaveAmount"} />
          <FormSwitchTC
            name={"onAccount"}
            tDefault={"Order on account"}
            tKey={"relations.form.algemeen.label.onAccount"}
          />
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Algemeen;
